module.exports = "/cyber/_next/static/images/steamSlide-4ba77f7cf0f24b5557557a00acf6f999.jpg";